<template>
  <div class="bg-dim flex-col">
    <div class="safe-area absolute">
      <div class="popup-wrap">
        <div class="stopusing-detail-top">
          <span class="card-image-border-none shadow" :style="{ backgroundImage:'url('+cardInfo.imageUrl+')'}"></span>
          <div>
            <em>{{ Number(cardInfo.remainCash).toLocaleString() }}</em>
            <strong>{{ cardInfo.prepaidCardNickName != null? cardInfo.prepaidCardNickName : cardInfo.giftMessage != null? cardInfo.giftMessage : '' }}</strong>
            <span>구매일<small>{{ cardInfo.issueDate }}</small></span>
          </div>
        </div>
        <div class="line-box">
          <div class="gray-line"></div>
        </div>
        <div class="popup-textbox">
          <span>해당 이마티콘을</span>
          <span>구매취소하시겠습니까?</span>
        </div>
      </div>

      <div class="button-wrap">
        <button class="button-bg-gray" @click="$router.push({ path: '/myemarticon/savebox' });">아니요</button>
        <button class="button-bg-yellow" @click="paymentVoidEvent()">예</button>
      </div>
    </div>
    <payment-void-popup v-if="paymentVoidPopupModal"></payment-void-popup>

  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import PaymentVoidPopup from "@/views/myemarticon/paymentVoidPopup.vue";
import apiList from "@/api/apiList";

export default {
  name: 'PaymentVoid',
  components: {BottomButton, PaymentVoidPopup},
  props: {
    cardInfo: {
      type: Object,
      required: true
    },
  },
  data() {
    return  {
      paymentVoidPopupModal : false,
      paymentVoidData : {
        ctmmnyNo : this.$store.state.partnerId,
        prepaidCardNo : this.cardInfo.prepaidCardNo,
        mberNo : this.$store.state.mberInfo.mberNo,
        requestId : this.$store.state.mberInfo.mberNo,
        method:"paymentVoid"
      },
    }
  },
  mounted() {
    this.$heading('구매취소');
  },
  methods : {
    paymentVoidEvent() {
      const params = this.paymentVoidData;

      apiList.putPrepaidPaymentVoid(params).then(res => {
        if(res.data != null && res.data.code == 'S00000') {
          this.paymentVoidPopupModal = true
        } else {
          alert(res.message);
        };
      });

    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/myemarticon/emarticonPaymentVoidPopup.scss';
</style>